// extracted by mini-css-extract-plugin
export var linkText = "_ny-0";